module.exports = __webpack_public_path__ + "img/undraw_online_payments_luau.3473e822.svg";